import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { Dialog, DialogContent, RadioGroup, Radio, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import Button from 'components/Button';
import { Filter } from 'typings/entities/clients';
import { theme } from 'theme';

import * as S from '../styled';

type Props = {
  open: boolean;
  close: () => void;
  handleFilterChange: (props: Filter) => void;
  handleResetFilter: () => void;
};

const Modal = ({ open, close, handleFilterChange, handleResetFilter }: Props) => {
  const { t } = useTranslation('common');
  const {
    handleSubmit,
    control,
    reset,
    formState: { isSubmitting },
  } = useForm();

  const onReset = () => {
    reset();
    handleResetFilter();
  };

  return (
    <Dialog onClose={close} open={open} fullWidth maxWidth="sm">
      <S.ModalTitle>
        {t('filter')}
        <IconButton onClick={close}>
          <CloseIcon />
        </IconButton>
      </S.ModalTitle>
      <DialogContent>
        <form onSubmit={handleSubmit(handleFilterChange)}>
          <Controller
            render={({ field }) => (
              <RadioGroup aria-label="status" {...field}>
                <S.RadioContainer>
                  <S.RadioLabel>{t('clientListPage.activeStatusLabel')}</S.RadioLabel>
                  <S.RadioControlLabel value="1" control={<Radio />} label={t('clientListPage.activeStatus')} />
                  <S.RadioControlLabel value="2" control={<Radio />} label={t('clientListPage.inactiveStatus')} />
                </S.RadioContainer>
              </RadioGroup>
            )}
            name="status"
            control={control}
          />
          <S.ButtonContainer>
            <S.ButtonWrapper>
              <Button
                textButton={t('saveButton')}
                buttonProps={{
                  bgColor: theme.colors.primary,
                  hoverColor: theme.colors.primaryShadow,
                  variant: 'contained',
                  type: 'submit',
                  disabled: isSubmitting,
                  startIcon: <DoneOutlinedIcon />,
                }}
              />
            </S.ButtonWrapper>
            <S.ButtonWrapper>
              <Button
                textButton={t('clientListPage.resetButton')}
                buttonProps={{
                  bgColor: theme.colors.red,
                  hoverColor: theme.colors.redShadow,
                  variant: 'outlined',
                  onClick: onReset,
                  disabled: isSubmitting,
                  startIcon: <RestartAltOutlinedIcon />,
                }}
              />
            </S.ButtonWrapper>
            <S.ButtonWrapper>
              <Button
                textButton={t('cancelButton')}
                buttonProps={{
                  bgColor: theme.colors.grey,
                  hoverColor: theme.colors.greyShadow,
                  variant: 'outlined',
                  onClick: close,
                  disabled: isSubmitting,
                  startIcon: <ClearOutlinedIcon />,
                }}
              />
            </S.ButtonWrapper>
          </S.ButtonContainer>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
